import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContactService {
  url = environment.url;
  constructor(private http: HttpClient) { }

  saveContactUsForm(data) {
    return this.http.post(this.url + 'saveContactUsDetails', data);
  }
}
